import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

export const finances: RouteRecordRaw = {
  name: 'admin.finances',
  path: 'finances',
  component: () => import('pages/Finances.vue'),
  meta: {
    roles: [
      Roles.CenterAdmin,
      Roles.OfficeStaff,
      Roles.OrgAdmin,
      Roles.SuperAdmin,
    ],
    supportedPlatforms: ['desktop'],
    excludeEnv: [],
  },
}
